<template>
    <div class="navs">
        <el-menu mode="vertical" :default-active="activePathIndx" background-color="#496cfc" text-color="#c5d3f8"
            active-text-color="#fff" @select="activeStoreIndx">
            <template>
                <el-submenu index="1">
                    <template slot="title">管理</template>
                    <el-menu-item-group>
                        <el-menu-item index="1-1">
                            <router-link to="/branch/branchCompanys"> 企业列表 </router-link>
                        </el-menu-item>
                        <el-menu-item index="1-2">
                            <router-link to="/branch/branchPolicy"> 人员列表 </router-link>
                        </el-menu-item>
                        <el-menu-item index="1-3">
                            <router-link to="/branch/statistList"> 统计列表 </router-link>
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </template>

        </el-menu>
    </div>
</template>

<script>

export default {
    data() {
        return {
            userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
            activePathIndx: sessionStorage.getItem('activePathIndx') || '1-1'
        }
    },
    methods: {
        activeStoreIndx(indx, indxPath) {
            console.log("indxPath", indxPath)
            sessionStorage.setItem('activePathIndx', indxPath[indxPath.length - 1])
        },
        sendDates() {
            this.ipost('/AdminTravel/TravelAgency.ashx?type=chageselfinsurancetime', {
                liabilitytime: this.liabilitytime,
                bondtime: this.bondtime
            }, res => {
                this.dateEditShow = false
                this.userInfo.TravelAgency_LiabilityTime = this.liabilitytime
                this.userInfo.TravelAgency_BondTime = this.bondtime
                this.overLibilitytime = Date.parse(this.now) > Date.parse(this.liabilitytime)
                this.overBondtime = Date.parse(this.now) > Date.parse(this.bondtime)
                sessionStorage.setItem('userInfo', JSON.stringify(this.userInfo))
                this.$message({
                    type: 'success',
                    message: '修改成功'
                })


            })
        }
    }
};
</script>

<style scoped>
.date-tips {
    padding: 12px;
    font-size: 13px;
    color: #ffff;
    position: relative;
    border-radius: 4px;
    margin: 2px;
    backdrop-filter: blur(10px);
    background: rgba(255, 255, 255, 0.2);
    box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2);
}

.red {
    color: red;
}

.date-tips-tit {
    font-weight: bold;
    font-size: 14px;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    letter-spacing: 1px;
}

.date-tips-btn {
    position: absolute;
    right: 3px;
    top: 3px;
    font-size: 12px;
    color: #ffffffb7;
}

.date-item-tips {
    position: relative;
    line-height: 37px;
}

.date-item-tips span {
    font-size: 16px;
}

.date-tips-min {
    font-size: 10px;
    margin-left: 8px;
    font-style: normal;
    transform: scale(.9);
    position: absolute;
    left: 83px;
    top: -6px;
}

.navs {
    height: 100%;
    background-color: #496cfc;
    overflow: hidden;
    overflow-y: auto;
}

.el-menu-item a {
    color: rgb(197 211 248);
    display: block;
}

.el-menu-item.is-active a {
    color: #fff;
}

.logo {
    background-color: #496cfc;
    height: 60px;
    text-align: center;
}

.logo img {
    height: 45px;
    margin-top: 7.5px;
}
</style>
